"use client";

import FootballFilterOddsAndBookmaker from "../FootballFilterOddsAndBookmaker";

export default function FootballMatchHeader({
  extendValue,
  bookmakerValue,
  extendOptions,
  bookmakerOptions,
  onExtendChange,
  onBookmakerChange,
}) {
  return (
    <tr id="tr_0" className="scoretitle hidden md:table-row">
      <td className="w-[8%] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-table-header-bg,#626262)] p-[5px] text-center align-middle text-[13px] leading-[18px] text-[var(--theme-table-header-text,#ffffff)]">
        Giải
      </td>
      <td className="w-[8%] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-table-header-bg,#626262)] p-[5px] text-center align-middle text-[13px] leading-[18px] text-[var(--theme-table-header-text,#ffffff)]">
        Giờ
      </td>
      <td className="w-[16%] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-table-header-bg,#626262)] p-[5px] text-center align-middle text-[13px] leading-[18px] text-[var(--theme-table-header-text,#ffffff)]">
        Chủ
      </td>
      <td className="w-[14%] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-table-header-bg,#626262)] p-[5px] text-center align-middle text-[13px] leading-[18px] text-[var(--theme-table-header-text,#ffffff)]">
        Tỷ số
      </td>
      <td className="w-[16%] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-table-header-bg,#626262)] p-[5px] text-center align-middle text-[13px] leading-[18px] text-[var(--theme-table-header-text,#ffffff)]">
        Khách
      </td>
      <td
        className="w-[12%] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-table-header-bg,#626262)] py-[5px] text-center align-middle text-[13px] leading-[18px] text-[var(--theme-table-header-text,#ffffff)]"
        id="oddsHead"
      >
        C/H-T
      </td>
      <td
        className="w-[8%] min-w-[86px] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-table-header-bg,#626262)] p-[5px] text-center align-middle text-[13px] leading-[18px] text-[var(--theme-table-header-text,#ffffff)]"
        id="HtTh"
      >
        Số liệu
      </td>
      <td className="w-[31%] min-w-[140px] rounded-r-[4px] border-b border-solid border-[var(--theme-border)] border-x-0 border-t-0 bg-[var(--theme-table-header-bg,#626262)] p-[5px] text-center align-middle text-[13px] leading-[18px] text-[var(--theme-table-header-text,#ffffff)]">
        <FootballFilterOddsAndBookmaker
          extendValue={extendValue}
          bookmakerValue={bookmakerValue}
          extendOptions={extendOptions}
          bookmakerOptions={bookmakerOptions}
          onExtendChange={onExtendChange}
          onBookmakerChange={onBookmakerChange}
        />
      </td>
    </tr>
  );
}

